import React, { PropsWithChildren, useCallback, useState } from 'react';
import { saleTypeOptions } from '../../constants';
import { SaleType, SaleStructureType } from '../../types';
import { saleModeContext as SaleModeContext, SaleModeValues } from './saleModeContext';

interface SaleModeContextProps {
  initialValues?: SaleModeValues;
}

export const SaleModeProvider = ({ children, initialValues }: PropsWithChildren<SaleModeContextProps>) => {
  console.log(initialValues);

  const [state, setState] = useState<Omit<SaleModeValues, 'options'>>(
    initialValues ?? {
      isCash: false,
      isFinancing: true,
      saleType: SaleType.Financing,
      saleStructureType: SaleStructureType.Finance,
    }
  );

  const handleChangeMode = useCallback((saleType: SaleType) => {
    setState(prev => ({
      ...prev,
      saleType,
      isCash: saleType === SaleType.Cash,
      isFinancing: saleType === SaleType.Financing,
      saleStructureType: saleType === SaleType.Cash ? SaleStructureType.AftermarketMenu : SaleStructureType.Finance,
    }));
  }, []);

  const handleChangeStructureType = useCallback((saleStructureType: SaleStructureType) => {
    setState(prev => ({ ...prev, saleStructureType }));
  }, []);

  return (
    <SaleModeContext.Provider
      value={{
        ...state,
        onChangeSaleType: handleChangeMode,
        onChangeStructureType: handleChangeStructureType,
        options: initialValues?.options ?? saleTypeOptions,
      }}
    >
      {children}
    </SaleModeContext.Provider>
  );
};
